<template>
  <div class="w-100">
    <div class="row justify-content-center align-items-center stepFormTwo">
      <div class="stepArea my-5 middleBox">
        <div class="whiteBG p-3 Step-Form">
          <loader
            :pageloader_value="pageLoader"
            :type="'complete'"
            v-if="pageLoader"
          ></loader>
          <message
            :message="response_msg"
            :messageType="msg_type"
            v-if="response_msg != ''"
          ></message>

          <div class="stepForm row">
            <div class="col-12 mobPad">
              <ul class="step-4">
                <li>
                  <label class="text-left fancy_radiochk_btn"
                    >{{ $t("step4_readaccept") }}
                    <a :href="$env_var.ClientAgreement" target="_blank()"
                      >Partners Agreement
                    </a>
                    and

                    <a :href="$env_var.OrderExecutionPolicy" target="_blank()">
                      {{ $t("step4_privacyplicy") }}</a
                    >
                    <input
                      type="checkbox"
                      class="form-control"
                      v-model="check2"
                      v-validate="'required'"
                      name="check2"
                      :class="{
                        'is-invalid': submitted && errors.has('check2'),
                      }"
                      ref="check2Input"
                      :disabled="disable"
                    /><span class="checkmark"></span>
                    <p
                      class="error"
                      v-if="submitted"
                      v-for="error in errors.collect('check2')"
                    >
                      {{ $t("step4_termsAgreeRqd") }}
                    </p>
                  </label>
                </li>

                <li>
                  <label class="text-left fancy_radiochk_btn"
                    >{{ $t("step4_policytwo") }}
                    <input
                      type="checkbox"
                      class="form-control"
                      v-model="check4"
                      v-validate="'required'"
                      name="check4"
                      :class="{
                        'is-invalid': submitted && errors.has('check4'),
                      }"
                      ref="check4Input"
                      :disabled="disable"
                    /><span class="checkmark"></span>
                    <p
                      class="error"
                      v-if="submitted"
                      v-for="error in errors.collect('check4')"
                    >
                      {{ $t("step4_termsAgreeRqd") }}
                    </p>
                  </label>
                </li>
              </ul>
            </div>

            <div class="col-12 mobPad">
              <div class="step-bottom-alert">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="custom-class feather feather-alert-circle"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12" y2="16"></line>
                  </svg>
                </span>
                <p>
                  {{ $t("step4_AfterCalling") }} "{{
                    $t("step4_saveContinue")
                  }}", {{ $t("step4_allInfoCorrect") }}
                </p>
              </div>
            </div>

            <div class="col-12 mobPad">
              <div
                class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100"
              >
                <button class="prism_btn btn_sm" v-on:click.prevent="submit()">
                  {{ $t("step4_saveContinue") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from "@/types";
import { mapActions } from "vuex";
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "stepFour",
  mixins: [fxViewMixins],
  data() {
    return {
      step: 2,
      check2: false,
      check4: false,
      submitted: false,
      response_msg: "",
      msg_type: "",
      pageLoader: false,
      type_msg: "",
      text: false,
      select_lang: "",

      disable: false,
    };
  },
  computed: {
    languageChangeDetectFunc() {
      if (this.$root.$children[0].languageChangeDetect != "es") {
        this.type_msg = "";
      }
      //console.log('languageChangeDetect in step4===========',this.$root.$children[0].languageChangeDetect)
    },
  },
  methods: {
    closeModalFunc() {
      this.$parent.$parent.showStepComponent = false;
    },
    ...mapActions({
      _runRegisterStepFour: types.RUN_REGISTER_STEP4,
    }),
    submit() {
      if (this.disable) {
        this.$router.replace("/step3");
      } else {
        const _that = this;
        _that.submitted = true;
        _that.$validator.validate().then((valid) => {
          if (valid) {
            let input_json = {
              globalParams: {
                terms_agreed: 1,
                type_msz_for_spain_user: _that.type_msg,
                step: _that.step,
              },
              localParams: {
                parameter: _that,
              },
            };
            _that._runRegisterStepFour(input_json);
          } else {
            _that.handleValidationErrorAdvanced(_that.errors);
          }
        });
      }
    },
  },
  created() {
    this._runGetUserRegisterationStepData({
      globalParams: {},
      localParams: { parameter: this, step: "2" },
    });

    this.select_lang = localStorage.getItem("lang");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step4.vue